import(/* webpackMode: "eager" */ "/home/academyr/crm.24agency.ro/src/assets/scss/app.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/academyr/crm.24agency.ro/src/components/wrappers/AppProvidersWrapper.jsx");
